<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_5">
					<em class="lt_text">Invoice Date For <b>Launch</b></em>
					<span class="mgr_15"> <CustomDatePicker v-model="fromDateForLaunch"/> ~ <CustomDatePicker v-model="toDateForLaunch"/></span>

					<item-class-group v-model="itemClassGroupCode"></item-class-group>
					<item-department-a v-model="itemDepartmentACode"></item-department-a>
					<item-department-b v-model="itemDepartmentBCode"></item-department-b>

					<em class="lt_text">Invoice Date For <b>Stores</b></em>
					<span class="mgr_5"> <CustomDatePicker v-model="fromDateForStores" :disabled="this.isNotApplyPeriodForStores" /> ~ <CustomDatePicker v-model="toDateForStores" :disabled="this.isNotApplyPeriodForStores" /> </span>
					<label class="mgr_5"><input type="checkbox" v-model="isNotApplyPeriodForStores" @change="notApplyPeriodForStores" /> Not Apply</label>
					<label class="mgr_15"><input type="checkbox" v-model="isEqualToPeriodForLaunch" @change="equalToPeriodForLaunch" :disabled="this.isNotApplyPeriodForStores" /> Equal to Period For Launch</label>

					<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
					<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
				</p>
				<item-class-select-multi-s v-model="classList" />
			</div>
		</div>
		<div class="fixed-table-container">
			<div class="mgb_20 table-wrapper" style="margin: 0 auto;">
				<div class="al_center" style="margin: 0 auto;">
					<label class="mgr_5">
						<em class="lt_text">Stores</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="grandTotal.totalStores | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Launch</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="grandTotal.totalLaunch | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Not</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="grandTotal.totalNot | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Rates</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="grandTotal.totalRate | toCurrency" />%
					</label>
				</div>
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 15%" />
						<col style="width: 10%" />
						<col />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
						<col style="width: 10%" />
					</colgroup>

					<thead>
						<tr>
							<th>Team</th>
							<th>Sales</th>
							<th>Sales</th>
							<th>Stores</th>
							<th>Launch</th>
							<th>Not</th>
							<th>Rates</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="root && root.length">
							<template v-for="rate in root">
								<tr :key="rate.classCode">
									<td colspan="7">{{ rate.classCode }} / {{ rate.className }}</td>
								</tr>
								<template v-if="rate.list && rate.list.length">
									<template v-for="team in rate.list">
										<template v-if="team.list && team.list.length">
											<template v-for="(group, groupIndex) in team.list">
												<tr :key="rate.classCode + group.salesGroupCode">
													<td>{{ groupIndex === 0 ? team.description : '' }}</td>
													<td class="al_center">{{ group.salesGroupCode }}</td>
													<td class="al_left">{{ group.salesGroupName }}</td>
													<td class="al_right">{{ group.stores | commaSeparated }}</td>
													<td class="al_right">{{ group.launch | commaSeparated }}</td>
													<td class="al_right">{{ group.not | commaSeparated }}</td>
													<td class="al_right">{{ group.rate | toCurrency }}%</td>
												</tr>
											</template>
										</template>
									</template>
								</template>

								<tr :key="'r' + rate.classCode">
									<td colspan="3" class="al_right">TOTAL</td>
									<td class="al_right">{{ rate.sumStores | commaSeparated }}</td>
									<td class="al_right">{{ rate.sumLaunch | commaSeparated }}</td>
									<td class="al_right">{{ rate.sumNot | commaSeparated }}</td>
									<td class="al_right">{{ rate.sumRate | toCurrency }}%</td>
								</tr>
							</template>
						</template>
						<tr>
							<td colspan="3" class="al_right">Grand Total</td>
							<td class="al_right">{{ grandTotal.totalStores | commaSeparated }}</td>
							<td class="al_right">{{ grandTotal.totalLaunch | commaSeparated }}</td>
							<td class="al_right">{{ grandTotal.totalNot | commaSeparated }}</td>
							<td class="al_right">{{ grandTotal.totalRate | toCurrency }}%</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiGetReportTemplate, exportFile, exportFileType, objectToFormData, Report, reportMrtUrl } from '@/api/util';
import { apiLandingRates } from '@/api/report/report';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { today, toYear, calcDate } from '@/utils/date';
import { convertFalsyToEmpty } from '@/utils/etc';

import ItemClassGroup from '@/components/common/ItemClassGroup.vue';
import ItemDepartmentA from '@/components/common/ItemDepartmentA.vue';
import ItemDepartmentB from '@/components/common/ItemDepartmentB.vue';

export default {
	props: ['headers'],
	data: function() {
		return {
			classList: [],
			root: [],
			fromDateForLaunch: null,
			toDateForLaunch: null,
			fromDateForStores: null,
			toDateForStores: null,
			isNotApplyPeriodForStores: false,
			isEqualToPeriodForLaunch: false,
			itemClassGroupCode: '',
			itemDepartmentACode: '',
			itemDepartmentBCode: '',
		};
	},
	components: {
		ItemClassSelectMultiS,
		CustomDatePicker,
		ItemClassGroup,
		ItemDepartmentA,
		ItemDepartmentB,
	},
	computed: {
		grandTotal: {
			get() {
				let totalStores = 0;
				let totalLaunch = 0;

				if (this.root && this.root.length) {
					totalStores = this.root[0].sumStores;
					this.root[0].list.forEach(el => {
						if (el.list) {
							el.list.forEach(e => {
								totalLaunch += e.totalLaunch;
							});
						}
					});
				}

				return {
					totalStores,
					totalLaunch,
					totalNot: totalStores - totalLaunch,
					totalRate: totalStores ? (totalLaunch / totalStores) * 100 : 0,
				};
			},
		},
		arePeriodsTheSame: {
			get() {
				return this.fromDateForLaunch === this.fromDateForStores && this.toDateForLaunch === this.toDateForStores;
			},
		},
	},
	watch: {
		arePeriodsTheSame: {
			handler(boolean) {
				if (!boolean && this.isEqualToPeriodForLaunch) {
					this.isEqualToPeriodForLaunch = false;
				}
			},
		},
	},
	methods: {
		notApplyPeriodForStores() {
			if (this.isNotApplyPeriodForStores) {
				this.fromDateForStores = null;
				this.toDateForStores = null;
				this.isEqualToPeriodForLaunch = false;
			} else {
				this.toDateForStores = today();
				this.fromDateForStores = calcDate(this.toDateForStores, -365);
			}
		},
		equalToPeriodForLaunch() {
			if (this.isEqualToPeriodForLaunch) {
				this.fromDateForStores = this.fromDateForLaunch;
				this.toDateForStores = this.toDateForLaunch;
			}
		},
		reset() {
			this.classList = [];
			this.fromDateForLaunch = '01-01-' + toYear();
			this.toDateForLaunch = today();
			this.isNotApplyPeriodForStores = true;

			this.notApplyPeriodForStores();
		},
		async search() {
			if (this.classList.length < 1) {
				this.$toast.error(`${this.headers.class} Code not selected.`);
				return false;
			}

			const paramObj = {
				classList: this.classList,
				from_date_for_launch: convertFalsyToEmpty(this.fromDateForLaunch),
				to_date_for_launch: convertFalsyToEmpty(this.toDateForLaunch),
				from_date_for_stores: convertFalsyToEmpty(this.fromDateForStores),
				to_date_for_stores: convertFalsyToEmpty(this.toDateForStores),
				class_group_code: convertFalsyToEmpty(this.itemClassGroupCode),
				item_department_a: convertFalsyToEmpty(this.itemDepartmentACode),
				item_department_b: convertFalsyToEmpty(this.itemDepartmentBCode),
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiLandingRates(param);

			this.root = data;
		},
		async excel() {
			if (this.root && this.root.length) this.root[0].totalLaunch = this.grandTotal.totalLaunch;
			// console.log(JSON.stringify(this.root));
			const reportTemplate = await apiGetReportTemplate('LandingRates', reportMrtUrl('LandingRates'));
			const report = new Report(reportTemplate, this.root, 'LandingRates');
			exportFile(report, exportFileType.excel);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_landingRates');
		this.$store.commit('setSubTitle', 'Report -> Landing Rates');

		this.reset();
	},
	mounted() {},
};
</script>

<style></style>
